import React, { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

import {
  ContainerLabels,
  Disclaimer,
  DynamicFormFields,
  FieldContainer,
  Form,
  LabelSpan,
  ReturnButton,
  SubmitButton
} from './styles'
import { FeedbackTypeSelector } from '../FeedbackTypeSelector'
import { Divider, Inline } from '~/styles'
import { LabelForm, TextAreaForm } from '~/components/shared'
import { message } from '~/services'
import { EFeedbackType, IFeedbackValues } from '~/interfaces'

const schema = Yup.object().shape({
  type: Yup.string().oneOf(Object.values(EFeedbackType)).required(),
  feedback: Yup.string().min(3).required()
})

interface ContentProps {
  onSubmit: (data: IFeedbackValues) => void
}

export const Content = ({ onSubmit }: ContentProps): JSX.Element => {
  const { resetField, reset, handleSubmit, formState, watch, register } = useForm<IFeedbackValues>({
    resolver: yupResolver(schema),
    mode: 'all',
    reValidateMode: 'onChange'
  })

  const watchFieldType = watch('type')

  useEffect(() => {
    resetField('feedback')
  }, [watchFieldType, resetField])

  const onReturnToChooseFeedbackType = useCallback(() => {
    reset()
  }, [reset])

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FeedbackTypeSelector register={register('type')} selectedType={watchFieldType} />

      <DynamicFormFields show={!!watchFieldType}>
        <FieldContainer>
          <ContainerLabels>
            <LabelForm>{message('feedback.feedbackDescription')}</LabelForm>
            <LabelSpan>{message('feedback.feedbackRequired')}</LabelSpan>
          </ContainerLabels>
          <TextAreaForm register={register('feedback')} />
        </FieldContainer>

        <Divider />

        <Disclaimer>{message('feedback.submit_disclaimer')}</Disclaimer>

        <Inline justifyContent="center">
          <ReturnButton disabled={formState.isSubmitting} onClick={onReturnToChooseFeedbackType} />
          <SubmitButton disabled={!formState.isValid} isLoading={formState.isSubmitting} />
        </Inline>
      </DynamicFormFields>
    </Form>
  )
}
